var exports = {
  "k": "SteppedCarousel.module__container___cnFRT0",
  "d": "SteppedCarousel.module__pane___cnFRT0",
};

module.exports = exports;
